import React from 'react'
import { Separator, useContainerWidth } from '@fs/zion-ui'

export default function ResponsiveSeparator({ defaultSize = 'md' }) {
  const atWidth = useContainerWidth()
  return <Separator size={atWidth({ default: defaultSize, md: 'md', lg: 'lg', xl: 'xl' })} data-testid="separator" />
}
